<template>
<v-card>
  <request-status :request='req' :message200='false' />
  <v-card-title v-if='withTitle' class='overline py-0' >
    <v-btn small icon @click='get' :loading='req.loading' >
      <v-icon small >replay</v-icon>
    </v-btn>
    <strong>{{appointment.title | appointment.full_name}}</strong>
  </v-card-title>
  <v-divider/>
  <v-card-text
    v-if='financials'
    style='text-align:right;' >
    <div class='li' >
      <span class='overline' >Appointment price</span><br/>
      <strong>{{ formatCurrency(appointment.currency, financials.appointment_unit_price) }}</strong>
    </div>

    <div class='li'
      v-if='financials.products_total_price && parseInt(financials.products_total_price) > 0' >
      <span class='overline' >Product sales</span><br/>
      <strong>{{ formatCurrency(appointment.currency, financials.products_total_price) }}</strong>
    </div>
    <div class='li'
      v-if='financials.appointment_tax && parseInt(financials.appointment_tax) > 0' >
      <span class='overline' >Tax</span><br/>
      <strong>{{ formatCurrency(appointment.currency, financials.appointment_tax) }}</strong>
    </div>
    <v-divider class='my-2' />
    <div class='li'
      v-if='financials.appointment_dicount && parseInt(financials.appointment_dicount) > 0' >
      <span class='overline' >Discount</span><br/>
      <strong>{{ formatCurrency(appointment.currency, financials.appointment_dicount) }}</strong>
    </div>
    <div class='li' >
      <span class='overline' >Payments</span><br/>
      <strong>{{ formatCurrency(appointment.currency, financials.payments_received) }}</strong>
    </div>

    <v-divider />
    <div >
      <span class='overline' >Due</span><br/>
      <strong class='headline' >{{ formatCurrency(appointment.currency, finalPrice) }}</strong>
    </div>
  </v-card-text>

</v-card>
</template>
<script>
export default {
  name: 'AppointmentPriceDetails',
  props: {
    appointmentId: { required: false },
    value: { type: Object, required: false },
    touch: { type: Number, default: 0 },
    withTitle: { type: Boolean, default: true }
  },
  data () {
    return {
      req: {
        resource: 'ag.practitioner.appointments'
      }
    }
  },
  computed: {
    requestStatus () {
      return this.req.status
    },
    appointment () {
      return this.getObjectPath(this.req, 'result', {})
    },
    financials () {
      let remoteFinancials = this.getObjectPath(this.req, 'result.financials', null)
      if (this.appointmentId && remoteFinancials) {
        return remoteFinancials
      }
      if (this.value) { return this.value }
      return {}
    },
    finalPrice () {
      return this.getObjectPath(this.financials, 'final_due')
    }
  },
  watch: {
    appointmentId: {
      immediate: true,
      handler () {
        this.get()
      }
    },
    touch () {
      this.get()
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.$emit('update:financials', this.financials)
      }
    },
    finalPrice (val) {
      this.$emit('finalprice', val)
    }
  },
  methods: {
    get () {
      if (this.appointmentId) {
        this.req.resourceId = this.appointmentId
        this.$request('get', this.req)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppointmentPriceDetails.vue?619dedc8